function isToday(date: Date) {
  const today = new Date()
  return (
    date.getDate() == today.getDate() &&
    date.getMonth() == today.getMonth() &&
    date.getFullYear() == today.getFullYear()
  )
}

function convertUTCToFuWTime(IsoStringUTC: string) {
  const d = new Date(IsoStringUTC)

  const tzo = -d.getTimezoneOffset()
  const dif = tzo >= 0 ? "+" : "-"
  const pad = (num: number) => {
    const norm = Math.floor(Math.abs(num))
    return (norm < 10 ? "0" : "") + norm
  }
  return (
    d.getFullYear() +
    "-" +
    pad(d.getMonth() + 1) +
    "-" +
    pad(d.getDate()) +
    "T" +
    pad(d.getHours()) +
    ":" +
    pad(d.getMinutes()) +
    ":" +
    pad(d.getSeconds()) +
    dif +
    pad(tzo / 60) +
    ":" +
    pad(tzo % 60)
  )
}

function convertTimestampToDate(date: number | undefined) {
  if (date !== undefined) {
    const dateObj = new Date(date)
    return dateObj.toLocaleDateString("de-CH", {
      hour: "2-digit",
      minute: "2-digit",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
  } else {
    return "Invalid date"
  }
}

function formatDate(timestamp: string, locale = "de-CH"): string {
  return new Date(timestamp).toLocaleDateString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export { isToday, convertUTCToFuWTime, convertTimestampToDate, formatDate }
